// Core libraries
import React from 'react';

// External libs and components
import { createStyles, makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

// Internal libs

// Internal components

// Styles hook
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
  }),
);

// Props type
type SinglePageLayoutSpinnerProps = {};

// Component
const SinglePageLayoutSpinner = ({}: SinglePageLayoutSpinnerProps) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <CircularProgress />
    </div>
  );
};

export default SinglePageLayoutSpinner;
